import React from 'react';
import './QuestionPapersSection.css';

export default function QuestionPapersSection({ onSeeAllClick }) {
  return (
    <section id="question-papers" className="qp">
      <div className="qp__inner">

        {/* ── Title block ── */}
        <div className="qp__header">
          <div className="qp__eyebrow">
            <i className="fa-solid fa-file-lines"></i>
            <span>Student Support</span>
          </div>
          <h2 className="qp__title">
            Previous Year{' '}
            <span className="qp__title-accent">Question Papers</span>
          </h2>
          <p className="qp__subtitle">
            Access past examination papers to strengthen your preparation and
            understand the pattern of university assessments.
          </p>
        </div>

        {/* ── Image ── */}
        <div className="qp__image-wrap">
          {/* Decorative corner accents */}
          <span className="qp__corner qp__corner--tl" />
          <span className="qp__corner qp__corner--br" />

          <img
            src="/question_papers.png"
            alt="Question Papers collection"
            className="qp__image"
          />

          {/* Overlay CTA ribbon */}
          <div className="qp__overlay-ribbon">
            <div className="qp__ribbon-content">
              <i className="fa-solid fa-download"></i>
              <span>Access our previous year question papers archive online</span>
            </div>
            <button 
              className="qp__ribbon-btn" 
              onClick={onSeeAllClick} 
              style={{ border: 'none', cursor: 'pointer', background: '#f0c755', color: '#0e0f2e' }}
            >
              Browse Archive <i className="fa-solid fa-arrow-right"></i>
            </button>
          </div>
        </div>

      </div>
    </section>
  );
}
